export default {
  bulletsDirection: "row",
  bulletTextSize: "18px",
  bullets: [{ bulletText: "Support ticket management" }, { bulletText: "Creative requests" }]
};
